import membershipService from 'od-modules/secure_store/services/MembershipService';
import shoppingCartService from 'od-modules/secure_store/services/ShoppingCartService';
import {getStore} from 'od-modules/secure_store/store';
import localforage from 'localforage';

export const updateMembership = (dispatch) => membershipService.updateMembershipSubscription(getStore().prime.primeMemberSelected, dispatch);

export const refreshMembership = (dispatch) => membershipService.refreshMembershipSubscription(dispatch);

export const getMembershipSubscriptionDetails = (dispatch) => membershipService.getMembershipSubscriptionDetails(dispatch);

export const getMembershipInfo = (dispatch) => membershipService.getMembershipInfo(dispatch);

export const activateMembershipAutoRenewal = (dispatch) => membershipService.activateMembershipAutoRenewal(dispatch);

export const getShoppingCartFromDAPI = (dispatch) => shoppingCartService.getShoppingCart(dispatch);

export const createShoppingCartInDAPI = (data, flowProduct, isMeta, callback = () => {}) => {
    const actualBookingId = getStore().shoppingCart.bookingId;
    const createShoppingCartFlow = isMeta ? shoppingCartService.createShoppingCartResidentMeta : shoppingCartService.createShoppingCart;
    const createShoppingCartFn = flowProduct === 'dp' ? shoppingCartService.createDynpackShoppingCart : createShoppingCartFlow;
    return async(dispatch) => {
        const shoppingCart = await createShoppingCartFn.call(shoppingCartService, data, dispatch);
        const newBookingId = shoppingCart.bookingId;
        callback(actualBookingId, newBookingId);
        return saveShoppingCartAndExecuteCallback(shoppingCart, () => window.location.reload());
    };
};

export const saveShoppingCartAndExecuteCallback = (shoppingCart, callback) => {
    const bookingId = shoppingCart.bookingId || '';
    const promise = bookingId ? saveShoppingCartAndBookingId(bookingId) : Promise.resolve();
    return promise.then(() => callback(bookingId));
};

const saveShoppingCartAndBookingId = async(bookingId) => {
    await localforage.setItem('bookingId', bookingId);
    await localforage.setItem(`store${bookingId}`, getStore());
};
